<template>
  <SrpModal v-model:isVisible="isVisible">
    <template #content>
      <h1 class="global-h1" style="margin-bottom: 25px">What are Custom Packages?</h1>

      <!-- What happens guide -->
      <div class="what-happens-guide" style="margin-bottom: 20px">
        <!-- Guide item -->
        <div
          :class="{
            'guide-item': true,
            'guide-item--no-line-bottom-propagation': index === guideItemsList.length - 1,
            'what-happens-guide__guide-item': true,
          }"
          v-for="(guideItem, index) in guideItemsList"
          :key="index"
        >
          <div class="guide-item__icon-wrap">
            <img class="guide-item__icon" :src="`/images/${guideItem.icon}.svg`" :alt="guideItem.text" />
          </div>

          <div class="global-h4 guide-item__text">
            {{ guideItem.text }}
          </div>
        </div>
        <!-- / Guide item -->
      </div>
      <!-- / What happens guide -->
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import SrpModal from "@components/ui/SrpModal.vue";

// Toggle visibility ==========================================================
const isVisible = ref<boolean>(false);

// Guide items list ===========================================================
const guideItemsList = [
  { icon: "messageWithIndicator", text: "Creators and Destinations can find flexible ways to collaborate." },
  { icon: "checkmarkGreen", text: "Communicate the purpose, deliverables, and compensation to formalize a work agreement." },
  { icon: "moneyCircle", text: "Highlight the destination, deliver content, and get paid!" },
];

// Define expose ==============================================================
defineExpose({
  openModal: () => (isVisible.value = true),
});
</script>

<style scoped lang="scss">
// Guide item =================================================================
.guide-item {
  display: flex;
  position: relative;
  z-index: 0;

  &::before {
    content: "";
    width: 2px;
    height: calc(100% + 16px);
    border: 1px rgba(0, 0, 0, 0.15) solid;
    position: absolute;
    inset: 0 auto auto 27px;
    z-index: -1;
  }

  &--no-line-bottom-propagation {
    &::before {
      height: 10px;
    }
  }

  &__icon-wrap {
    width: 55px;
    min-width: 55px;
    height: 55px;
    margin-right: 13px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(235, 235, 235, 1);
  }

  &__icon {
    width: 62%;
  }

  &__text {
    flex-grow: 1;
    padding: 14px 16px 15px;
    border: 1px rgba(0, 0, 0, 0.15) solid;
    border-radius: 6px;
    font-weight: 500;
  }
}

// What happens guide =========================================================
.what-happens-guide {
  gap: 16px 0;
  display: flex;
  flex-direction: column;

  &__guide-item {
  }
}
</style>
